export const constantes = {
    KEY: "6Le-ty8UAAAAAIzeBUcFVqlrjjgWe5bjvrjsBQNj",
}

export const locales = {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Limpiar'
}


export const meses = [
    {value: '1', name: "Enero"},
    {value: '2', name: "Febrero"},
    {value: '3', name: "Marzo"},
    {value: '4', name: "Abril"},
    {value: '5', name: "Mayo"},
    {value: '6', name: "Junio"},
    {value: '7', name: "Julio"},
    {value: '8', name: "Agosto"},
    {value: '9', name: "Septiembre"},
    {value: '10', name: "Octubre"},
    {value: '11', name: "Noviembre"},
    {value: '12', name: "Diciembre"},
]
export const anios = [
    2017,
    2018,
    2019,
    2020,
    2021,
    2022,
    2023,
    2024,
    2025,
    2026,
    2027,
    2028,
    2029,
    2030,
    2031,
    2032,
    2033,
    2034,
    2035,
    2036,
    2037,
    2038,
    2039,
    2040,
]
